import React, {useState} from "react";
import {Badge, Button, Container} from "reactstrap";
import IconLabel from "../../shared/components/IconLabel";
import {ListIcon, PlusIcon} from "../../shared/components/icons";
import {formatDate} from "../../shared/utils/format";
import {appVersion} from "../../shared/utils/version";
import {CHANGELOG} from "./entries";

// How many entries show at first, and how many more each "Mostrar mais" adds.
const PAGE = 10;

const isFeature = (version) => version.endsWith(".0");

/** What changed in each version, newest first; the one running is marked. */
const Changelog = () => {
    const current = appVersion();
    const [shown, setShown] = useState(PAGE);
    return (
        <Container className="mt-4 mb-5" style={{maxWidth: 760}}>
            <h1 className="h4 mb-4">
                <IconLabel icon={<ListIcon size={20} />}>Novidades</IconLabel>
            </h1>
            {current && <p className="text-muted">Você está na versão {current}.</p>}
            {CHANGELOG.slice(0, shown).map(({version, date, changes}) => (
                <section key={version} className="mb-4">
                    <h2 className="h6 d-flex align-items-center gap-2 mb-1">
                        <span>v{version}</span>
                        {isFeature(version) && (
                            <Badge pill color="primary">
                                Novidade
                            </Badge>
                        )}
                        {version === current && (
                            <Badge pill color="secondary">
                                Versão atual
                            </Badge>
                        )}
                        <span className="small fw-normal text-muted ms-auto">
                            {/* noon, so the day is the same in every time zone */ formatDate(`${date}T12:00:00`)}
                        </span>
                    </h2>
                    <ul className="mb-0">
                        {changes.map((change) => (
                            <li key={change}>{change}</li>
                        ))}
                    </ul>
                </section>
            ))}
            {shown < CHANGELOG.length && (
                <Button color="primary" outline onClick={() => setShown(shown + PAGE)}>
                    <IconLabel icon={<PlusIcon />}>Mostrar mais</IconLabel>
                </Button>
            )}
        </Container>
    );
};

export default Changelog;
